import { Component, EventEmitter, OnInit, OnChanges, Input, Output, ViewChild, ElementRef } from '@angular/core';
// [[Providers]]

// ]
// [[]]
export class Pagination {
  total: number;
  per_page: number;
  current_page: number;
  total_pages: number;
  pages?: any;
}
// ]
@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css'],
})
export class PaginationComponent implements OnInit {
  /*
    "meta":{"pagination":{"total":18,"count":10,"per_page":10,"current_page":1,"total_pages":2
  */
  @Input() meta: any;
  @Input() per_page: any;
  @Input() paginantion_type: any; // normal | infinite
  @Output() fncDataIndex = new EventEmitter<number>();
  @ViewChild('goToPage', { static: false }) goToPage: ElementRef;
  // ----------------------------------------------------------------------------
  pagination = new Pagination();
  // ----------------------------------------------------------------------------

  /**
   *
   */
  ngOnInit() {
    if (typeof this.paginantion_type == 'undefined') {
      this.paginantion_type = 'normal';
    }
    this.createPagination(this.meta);
  }

  /**
   *
   */
  ngOnChanges() {
    this.createPagination(this.meta);
  }

  /**
   *
   * @param meta
   */
  createPagination(meta: any) {
    let per_page: any = [];
    if (meta !== undefined) {
      /**
       *  */
      var meta_pagination_object = {
        total: meta.total,
        per_page: meta.per_page,
        current_page: meta.current_page,
        total_pages: Math.ceil(meta.total / meta.per_page),
      };

      // -----------------------------------------------------------------------
      let pagination_cnt = !this.per_page ? 10 : this.per_page;
      let pagination_min = meta_pagination_object.current_page <= pagination_cnt / 2 ? 1 : meta_pagination_object.current_page - pagination_cnt / 2;
      let pagination_max = 10;
      if (meta_pagination_object.current_page == 1) {
        pagination_max = pagination_min + pagination_cnt;
      } else {
        pagination_max = pagination_min + (pagination_cnt % 2 ? pagination_cnt - 1 : pagination_cnt);
      }
      // -----------------------------------------------------------------------
      for (let i = Math.floor(pagination_min); i < pagination_max; i++) {
        if (i <= meta_pagination_object.total_pages) {
          per_page[i] = i;
        }
      }
      this.pagination = meta_pagination_object;
      this.pagination.pages = per_page.filter(Number);
    }
    // \ Pagination
  }

  doDataIndex(offset: any) {
    if (offset == null) {
      offset = this.goToPage.nativeElement.value;
    }
    this.fncDataIndex.emit(offset);
    this.pagination.current_page = offset;
    this.createPagination({ pagination: this.pagination });
    window.scrollTo(0, 0);
  }
}
